import React from 'react';

import clsx from 'clsx';
import PropTypes from 'prop-types';

import styles from '../sidebar.module.css';

import useCustomerLogo from '../helper/useCustomerLogo';

// The customer's logo as a small badge, or their initial without one.
function CustomerBrand({ companyName, className }) {
    const { logoUrl, logoKey, background, handleError } = useCustomerLogo();

    if (logoUrl) {
        return (
            <img
                key={logoKey}
                src={logoUrl}
                alt=""
                className={clsx(styles.customerBadge, className)}
                style={{ backgroundColor: background }}
                onError={handleError}
            />
        );
    }

    return (
        <span
            className={clsx(styles.customerBadge, styles.customerInitial, className)}
            aria-hidden="true"
        >
            {companyName.charAt(0).toUpperCase()}
        </span>
    );
}

CustomerBrand.propTypes = {
    companyName: PropTypes.string,
    className: PropTypes.string,
};

export default CustomerBrand;
